import { render, staticRenderFns } from "./account.vue?vue&type=template&id=31e137ca&scoped=true&"
import script from "./account.vue?vue&type=script&lang=js&"
export * from "./account.vue?vue&type=script&lang=js&"
import style0 from "./account.vue?vue&type=style&index=0&lang=css&"
import style1 from "./account.vue?vue&type=style&index=1&id=31e137ca&lang=less&scoped=true&"
import style2 from "./account.vue?vue&type=style&index=2&id=31e137ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e137ca",
  null
  
)

export default component.exports